import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	list: [],
	loading: false,
};

const allRolesSlice = createSlice({
	name: "roles",
	initialState,
	reducers: {
		setRolesList: (state, action) => {
			const { data } = action.payload;
			state.list = data || [];
		},
		setLoadingAllRoles: (state, action) => {
			state.loading = action.payload;
		},
	},
});

export const { setRolesList, setLoadingAllRoles } = allRolesSlice.actions;

export default allRolesSlice.reducer;
